module.exports = "<div class=\"loading\" [hidden]=\"!isLoading\">Loading&#8230;</div>\n<router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n"